module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_vm._v("Maps")])]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('p', {
    staticClass: "map-list"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#map_01"
    }
  }, [_c('span', {
    staticClass: "map_hang"
  }, [_vm._v("Map 1")]), _vm._v(" Afghanistan")])]), _vm._v(" "), _c('p', {
    staticClass: "map-list"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#map_02"
    }
  }, [_c('span', {
    staticClass: "map_hang"
  }, [_vm._v("Map 2")]), _vm._v(" Provinces of Afghanistan")])]), _vm._v(" "), _c('p', {
    staticClass: "map-list"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#map_03"
    }
  }, [_c('span', {
    staticClass: "map_hang"
  }, [_vm._v("Map 3")]), _vm._v(" Pashtun regions of Afghanistan")])]), _vm._v(" "), _c('p', {
    staticClass: "map-list"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#map_04"
    }
  }, [_c('span', {
    staticClass: "map_hang"
  }, [_vm._v("Map 4")]), _vm._v(" The Pashtun Belt")])]), _vm._v(" "), _c('p', {
    staticClass: "map-list"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#map_05"
    }
  }, [_c('span', {
    staticClass: "map_hang"
  }, [_vm._v("Map 5")]), _vm._v(" Individual tribes within the Pashtun Belt")])]), _vm._v(" "), _c('p', {
    staticClass: "map-list"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#map_06"
    }
  }, [_c('span', {
    staticClass: "map_hang"
  }, [_vm._v("Map 6")]), _vm._v(" The Pashtun pockets outside the Pashtun Belt")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('b', [_vm._v("Note on maps")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The maps showing the spread of the Pashtun tribes are approximations only. The tribes defy neat mapping, especially since Afghanistan’s recent conflicts prevent comprehensive collection of ethnic geospatial data, as well as having induced mass migrations and displacements. Endless Afghan turmoil since the 1980s has led to so much mixing of tribes that no clean-cut, easy-to-read tribal map will ever be entirely accurate. There will also be variations – even among Pashtuns – in how various regions are defined. The maps in this book should be approached with this in mind.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For example, there are varying views on the three Pashtun regions in "), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Maps#map_03"
    }
  }, [_vm._v("Map 3")]), _vm._v(". Herat Province is sometimes included in the region known as ‘Loy Kandahar’. The extent of the ‘Loya Paktia’ region varies among observers. This book includes Logar Province on the advice of a Pashtun expert, although some purists would dispute this. Other more liberal observers would also argue that parts of Ghazni and even Wardak provinces should be included. Different names will also be encountered. The ‘Loy Nangarhar’ region is often colloquially known as ‘Loy Mashriqi’ (Mashriqi means ‘Eastern’).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Maps#map_05"
    }
  }, [_vm._v("Map 5")]), _vm._v(" outlines the approximate spread of individual tribes within the Pashtun Belt. For readability, only the larger tribes or those prominent in this book are named. The names in bold represent tribes that are spread across a larger swathe of territory, while the other names signify a more specific area that the tribe is traditionally associated with or has an attachment to.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Maps#map_06"
    }
  }, [_vm._v("Map 6")]), _vm._v(" is based on first-hand engagement with local contacts in each province, but must also be considered as an approximation. The size and spread of the shaded areas are rough and are used only to illustrate the general area of small Pashtun pockets outside the Pashtun Belt whose presence is explained in this book.")]), _vm._v(" "), _c('div', {
    staticClass: "image_containerp",
    attrs: {
      "id": "map_01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/map01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("Map 1: Afghanistan")])]), _c('div', {
    staticClass: "image_containerp",
    attrs: {
      "id": "map_02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/map02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("Map 2: Provinces of Afghanistan")])]), _c('div', {
    staticClass: "image_containerp",
    attrs: {
      "id": "map_03"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/map03.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("Map 3: Pashtun regions of Afghanistan")])]), _c('div', {
    staticClass: "image_containerp",
    attrs: {
      "id": "map_04"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/map04.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("Map 4: The Pashtun Belt")])]), _c('div', {
    staticClass: "image_containerp",
    attrs: {
      "id": "map_05"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/map05.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("Map 5: Individual Tribes within the Pashtun Belt")])]), _c('div', {
    staticClass: "image_containerp",
    attrs: {
      "id": "map_06"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/map06.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("Map 6: The Pashtun pockets outside the Pashtun Belt")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68decf01","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Maps.vue
// module id = 78
// module chunks = 0